<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['item.no']" :placeholder="$t('business.label.itemNo')" @pressEnter="search()" @search="search()" />
      <a-input-search v-model="query['item.name']" :placeholder="$t('business.label.itemName')" @pressEnter="search()" @search="search()" />
      <a-input-search v-model="query['lot.no']" :placeholder="$t('business.label.lot')" @pressEnter="search()" @search="search()" />
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>rowDblClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80" />
      <vxe-column field="item.name" title="business.label.itemName" width="200" />
      <vxe-column field="pack.specification" title="business.label.specification" width="200" />
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150" />
      <vxe-column field="lot.no" title="business.label.lot" width="150" />
      <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150" />
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100" />
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100" />
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150" />
      <vxe-column field="detail.receivingman" title="business.label.inspector" width="150" />
      <vxe-column field="detail.invoiceQuantity" title="business.label.invoiceQuantity" width="150" />
      <vxe-column field="detail.receivedQuantity" title="business.label.receivedQuantity" width="150" />
      <vxe-column field="detail.rejectedQuantity" title="business.label.rejectedQuantity" width="150" />
      <vxe-column field="detail.inspectedQuantity" title="business.label.inspectedQuantity" width="150" />
      <vxe-column field="detail.acceptedQuantity" title="business.label.acceptedQuantity" width="150" />
      <vxe-column field="detail.rejectedQuantityOfAcceptance" title="business.label.rejectedQuantityOfAcceptance" width="150" />
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'InspectDetail',
    data() {
      return {
        loading: false,
        query: {
          'order.id': null,
          'item.no': '',
          'item.name': '',
          'lot.no': ''
        },
        data: [],
        page: 1,
        size: 10,
        contentSize: 0,
        height: Vue.ls.get(SCREEN_HEIGHT) * (0.475)
      }
    },
    methods: {
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      search() {
        this.page = 1
        this.getData()
      },
      getData(orderId) {
        if (orderId) {
          this.query['order.id'] = orderId
        }
        if (this.query['order.id'] === null || this.query['order.id'] === undefined) {
          return
        }
        this.loading = true
        findAll('receiptDetailFactory', this.query, this.page, this.size).then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
          }
          this.loading = false
        })
      },
      rowDblClick(row) {
        this.$emit('rowDblClick', row)
      },
      reset() {
        this.query['item.no'] = ''
        this.query['item.name'] = ''
        this.query['lot.no'] = ''
      }
    }
  }
</script>
